import React from 'react'
import Typo from '../typo/Typo'

export const AppH5Header = (props) => {
    return (
        <div className='section-gap border-bt'>
            <Typo variant='h5' text={props.text} color="secondary" />
        </div>
    )
}

export const AppH6Header = (props) => {
    return (
        <div className='section-gap'>
            <Typo variant='h6' text={props.text} color="secondary" />
        </div>
    )
}
